"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8085],{

/***/ 11145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export GenericList */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var GenericList = function(param) {
    var data = param.data, listKey = param.listKey, renderItem = param.renderItem, emptyComponent = param.emptyComponent, errorComponent = param.errorComponent, loadingComponent = param.loadingComponent, className = param.className, itemClassName = param.itemClassName, beforeList = param.beforeList, afterList = param.afterList, itemWrapperClassName = param.itemWrapperClassName, _dataState = param.dataState, dataState = _dataState === void 0 ? "idle" : _dataState;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            (data === null || data === void 0 ? void 0 : data.length) > 0 && !!beforeList ? beforeList : null,
            function() {
                var renderedComponent;
                switch(dataState){
                    default:
                    case "idle":
                    case "loading":
                        var /*#__PURE__*/ ref;
                        renderedComponent = (ref = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "data-testid": "loading-list",
                            children: loadingComponent
                        })) !== null && ref !== void 0 ? ref : null;
                        break;
                    case "error":
                        var /*#__PURE__*/ ref1;
                        renderedComponent = (ref1 = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "data-testid": "error-list",
                            children: errorComponent
                        })) !== null && ref1 !== void 0 ? ref1 : null;
                        break;
                    case "success":
                        var /*#__PURE__*/ ref2;
                        renderedComponent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            "data-testid": "success-list",
                            className: itemWrapperClassName ? itemWrapperClassName : undefined,
                            children: (data === null || data === void 0 ? void 0 : data.length) > 0 ? data.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: itemClassName,
                                    children: renderItem(item, index)
                                }, listKey(item));
                            }) : (ref2 = (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                "data-testid": "empty-list",
                                children: emptyComponent
                            })) !== null && ref2 !== void 0 ? ref2 : null
                        });
                        break;
                }
                return renderedComponent;
            }(),
            (data === null || data === void 0 ? void 0 : data.length) > 0 && !!afterList ? afterList : null
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GenericList);


/***/ }),

/***/ 18046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66261);
/* harmony import */ var _wartek_id_text__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89004);
/* harmony import */ var utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7379);
/* harmony import */ var utils_hooks_context_useScreenSizeContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(65260);
/* provided dependency */ var process = __webpack_require__(34155);











var trackClick = function(actionType) {
    (0,utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_5__/* .GATrackEvent */ .l)({
        eventName: "learning_activity",
        eventParams: {
            event_trigger: "ab_test_tabbed_menu",
            action_type: actionType
        },
        sendDefaultParams: true
    });
};
var defaultNavItems = [
    {
        name: "untuk-anda",
        label: "Untuk Anda",
        href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri")
    },
    {
        name: "topik",
        label: "Topik",
        href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/daftar-topik")
    },
    {
        name: "aksi-nyata",
        label: "Aksi Nyata",
        href: "/".concat(process.env.NEXT_PUBLIC_TEMP_PELATIHAN_MANDIRI_PATH || "pelatihan-mandiri", "/daftar-aksi-nyata")
    }, 
];
var scrollNavs = [
    {
        name: "rekomendasi-belajar",
        label: "Rekomendasi belajar",
        image: "https://storage.googleapis.com/microlearning-public-production/web-assets/kumpulan-tema-icon.png"
    },
    {
        name: "progress-topik",
        label: "Progres topik",
        image: "https://storage.googleapis.com/microlearning-public-production/web-assets/progress-topic-icon.png"
    },
    {
        name: "webinar",
        label: "Webinar",
        image: "https://storage.googleapis.com/microlearning-public-production/web-assets/webinar-icon.png"
    }, 
];
var TabbedNav = function(param) {
    var activeMenu = param.activeMenu, _navItems = param.navItems, navItems = _navItems === void 0 ? defaultNavItems : _navItems, _absolutePosition = param.absolutePosition, absolutePosition = _absolutePosition === void 0 ? false : _absolutePosition, scrollClicked = param.scrollClicked, _isHideScrollNav = param.isHideScrollNav, isHideScrollNav = _isHideScrollNav === void 0 ? false : _isHideScrollNav, className = param.className;
    var isDesktop = (0,utils_hooks_context_useScreenSizeContext__WEBPACK_IMPORTED_MODULE_6__/* .useScreenSizeContext */ .fl)().isDesktop;
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().pathname;
    var isHomepagePelatihanMandiri = pathname === "/pelatihan-mandiri";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(true), 2), isSpyActive = ref[0], setIsSpyActive = ref[1];
    var handleScroll = function(param) {
        var name = param.name, label = param.label;
        react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .scroller.scrollTo */ .OK.scrollTo(name, {
            duration: 500,
            delay: 0,
            smooth: "smooth",
            offset: -230
        });
        scrollClicked({
            name: name,
            label: label
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .Events.scrollEvent.register */ .zW.scrollEvent.register("begin", function() {
            setIsSpyActive(false);
        });
        react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .Events.scrollEvent.register */ .zW.scrollEvent.register("end", function() {
            setIsSpyActive(true);
        });
        react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .scrollSpy.update */ .c5.update();
        return function() {
            react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .Events.scrollEvent.remove */ .zW.scrollEvent.remove("begin");
            react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .Events.scrollEvent.remove */ .zW.scrollEvent.remove("end");
        };
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("left-1/2 -translate-x-1/2 w-full z-20 bg-white -mt-0.5", absolutePosition ? "absolute" : "fixed", !isDesktop && "max-w-xl", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-stretch -mx-2 h-9 border-b",
                children: navItems.map(function(param) {
                    var name = param.name, label = param.label, href = param.href;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-2 flex-1 h-full text-center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: href,
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wartek_id_text__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
                                "data-testid": name,
                                onClick: function() {
                                    return trackClick(name);
                                },
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)("inline-block pb-2 border-b-4", activeMenu === name ? "border-icon-informational" : "border-transparent"),
                                variant: "action",
                                color: activeMenu === name ? "primary" : "subdued",
                                as: "a",
                                href: href,
                                children: label
                            })
                        })
                    }, name);
                })
            }),
            isHomepagePelatihanMandiri && !isHideScrollNav && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "grid grid-cols-3 gap-2 items-stretch p-4 shadow-md",
                children: scrollNavs.map(function(param) {
                    var name = param.name, label = param.label, image = param.image;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return handleScroll({
                                name: name,
                                label: label
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .Link */ .rU, {
                            to: name,
                            offset: -460,
                            spy: isSpyActive,
                            activeClass: "border-blue-50",
                            className: "pointer-events-none py-2 block border rounded-md text-center h-full",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: image,
                                        width: 32,
                                        height: 32,
                                        alt: name,
                                        className: "mb-1 mx-auto"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "text-xs font-bold",
                                        children: label
                                    })
                                ]
                            })
                        })
                    }, name);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TabbedNav);


/***/ }),

/***/ 35917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "L": function() { return /* binding */ useSETrackerEvent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/uuid/index.js
var uuid = __webpack_require__(55877);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./utils/fetchWithTimeout.ts




var DEFAULT_HTTP_TIMEOUT = 10000 // 10 seconds
;
function fetchWithTimeout(url, options) {
    return _fetchWithTimeout.apply(this, arguments);
}
function _fetchWithTimeout() {
    _fetchWithTimeout = (0,_async_to_generator/* default */.Z)(function(url, options) {
        var _timeout, timeout, controller, timeoutId, ref, response, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _timeout = options.timeout, timeout = _timeout === void 0 ? DEFAULT_HTTP_TIMEOUT : _timeout;
                    controller = new AbortController();
                    timeoutId = setTimeout(function() {
                        return controller.abort();
                    }, timeout);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        fetch(url, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                            signal: controller.signal
                        }))
                    ];
                case 2:
                    response = _state.sent();
                    return [
                        2,
                        response === null || response === void 0 ? void 0 : (ref = response.json) === null || ref === void 0 ? void 0 : ref.call(response)
                    ];
                case 3:
                    error = _state.sent();
                    console.error(error);
                    return [
                        3,
                        5
                    ];
                case 4:
                    clearTimeout(timeoutId);
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return _fetchWithTimeout.apply(this, arguments);
}

// EXTERNAL MODULE: ./configs/auth.ts
var auth = __webpack_require__(32178);
// EXTERNAL MODULE: ./utils/auth/index.tsx + 4 modules
var utils_auth = __webpack_require__(23475);
;// CONCATENATED MODULE: ./utils/satuEvent.ts






var getUserData = function() {
    var ref, ref1;
    var session = (0,utils_auth/* getSession */.Gg)();
    return {
        user_id: session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id,
        user_email: session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email
    };
};
/**
 * This is where you include all of your predefined parameters, eg. user_id, timestamp, etc.
 */ var getDefaultData = function() {
    return {
        id: (0,uuid.v4)(),
        timestamp: new Date().toISOString()
    };
};
var getPlatformData = function() {
    return {
        platform: window.AndroidHandler ? "APP" : "WEB"
    };
};
var useSatuEventTracker = function() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _mode = ref.mode, mode = _mode === void 0 ? "default" : _mode;
    var isEnabled = auth/* SATU_EVENT_CONFIG.enabled */.fW.enabled, debugEnabled = auth/* SATU_EVENT_CONFIG.debugEnabled */.fW.debugEnabled, url = auth/* SATU_EVENT_CONFIG.url */.fW.url, defaultUsername = auth/* SATU_EVENT_CONFIG.username */.fW.username, defaultPassword = auth/* SATU_EVENT_CONFIG.password */.fW.password, mengajar_username = auth/* SATU_EVENT_CONFIG.mengajar_username */.fW.mengajar_username, mengajar_password = auth/* SATU_EVENT_CONFIG.mengajar_password */.fW.mengajar_password;
    var USERNAME_MAPPING = {
        default: defaultUsername,
        mengajar: mengajar_username
    };
    var PASSWORD_MAPPING = {
        default: defaultPassword,
        mengajar: mengajar_password
    };
    var username = USERNAME_MAPPING[mode || "default"];
    var password = PASSWORD_MAPPING[mode || "default"];
    /**
   * Use this method to transform your standard `key:value` objects into a SatuEvent array-ready attributes
   *
   * @remarks
   *
   * In general, this function will return the following structure for every `key` you specified.
   * However, the `value` may only return one value based on its type.
   *
   * ```ts
   * {
   *    "key": "",
   *    "value": {
   *      "string_value": "1",
   *      "int_value": 1,
   *      "float_value": 1.00,
   *      "double_value": 1.00,
   *    }
   * }
   * ```
   *
   * @example
   * You can directly assign the `value` next to its `key`

   * ```ts
   * const attrs = { category: trackerParams.category }
   * SETransformAttrs(attrs);
   * ```
   *
   * @example
   * If you need to cast the value you can set the value as an array, where the first value should be the value itself.
   * While the second value, can be anything between `string` or `int` or `float` or `double`.
   *
   * ```ts
   * const attrs = { num_cp_blocks: [trackerParams.numOfBlocks, 'int'] }
   * SETransformAttrs(attrs);
   * ```
   *
   */ var SETransformAttrs = function(attrs) {
        return Object.keys(attrs).map(function(key) {
            var value = attrs === null || attrs === void 0 ? void 0 : attrs[key];
            var stringValue, intValue, floatValue, doubleValue, boolValue;
            // If not array
            if (!Array.isArray(value)) stringValue = value === null || value === void 0 ? void 0 : value.toString();
            else {
                var ref;
                var strValue = (ref = value[0]) === null || ref === void 0 ? void 0 : ref.toString();
                if (value[1] === undefined) stringValue = strValue;
                else if (value[0] !== undefined && value[1] !== undefined) {
                    if (value[1] === "string") {
                        stringValue = strValue;
                    } else if (value[1] === "int" && strValue !== "") {
                        intValue = parseInt(strValue, 10);
                        // To handle signed/negative zero, if the parsed strValue is rounded to 0
                        if (intValue === -0) intValue = 0;
                        // If not a number, return undefined
                        if (isNaN(intValue)) intValue = undefined;
                    } else if (value[1] === "float" && strValue !== "") {
                        floatValue = parseFloat(strValue);
                        // If not a number, return undefined
                        if (isNaN(floatValue)) floatValue = undefined;
                    } else if (value[1] === "double" && strValue !== "") {
                        doubleValue = parseFloat(strValue);
                        // If not a number, return undefined
                        if (isNaN(doubleValue)) doubleValue = undefined;
                    } else if (value[1] === "bool" && strValue !== "") {
                        boolValue = Boolean(value[0]);
                        // If not a boolean, return undefined
                        if (typeof value[0] !== "boolean") boolValue = undefined;
                    }
                }
            }
            return {
                key: key,
                value: {
                    string_value: stringValue,
                    int_value: intValue,
                    float_value: floatValue,
                    double_value: doubleValue,
                    bool_value: boolValue
                }
            };
        });
    };
    /**
   * @param {Object}    props - Satu Event properties
   * @param {string}    props.eventName - The event name
   * @param {string}    props.eventParams - The event params
   * @param {bolean}    props.sendDefaultParams - Should the IDs included within the event? eg. id, timestamp
   * @param {bolean}    props.sendUserData - Should the user data included within the event? eg. user_id
   * @param {function}  [props.callback] - [Optional] The callback function that the tracker will call after the request is send (both success or failed)
   * @param {number}    [props.timeout] - Timeout in miliseconds. Recommended to be set for some cases
   */ var SETrackEvent = function(param) {
        var eventName = param.eventName, eventParams = param.eventParams, _sendDefaultParams = param.sendDefaultParams, sendDefaultParams = _sendDefaultParams === void 0 ? true : _sendDefaultParams, _sendUserData = param.sendUserData, sendUserData = _sendUserData === void 0 ? false : _sendUserData, _callback = param.callback, callback = _callback === void 0 ? function() {} : _callback, timeout = param.timeout, keepAlive = param.keepAlive;
        var ref;
        if (!isEnabled || !url) {
            if (debugEnabled) console.error("[SatuEvent] Tracker disabled");
            return;
        }
        var params = (0,_object_spread/* default */.Z)({}, eventParams);
        if (sendDefaultParams) {
            params = (0,_object_spread/* default */.Z)({}, getDefaultData(), params);
            if (mode === "mengajar") params = (0,_object_spread/* default */.Z)({}, getPlatformData(), params);
        }
        if (sendUserData) params = (0,_object_spread/* default */.Z)({}, params, getUserData());
        if (debugEnabled) {
            // eslint-disable-next-line no-console
            console.log("[SatuEvent]", eventName, JSON.stringify(params));
        }
        var requestBody = (0,_object_spread/* default */.Z)({
            event_name: eventName
        }, ((ref = Object.keys(params)) === null || ref === void 0 ? void 0 : ref.length) > 0 ? {
            data: JSON.stringify(params)
        } : {});
        // allow tracker requests to outlive the page (when redirected) and no need to wait a callback
        // reference: https://developer.mozilla.org/en-US/docs/Web/API/fetch#keepalive
        if (keepAlive) {
            fetchWithTimeout(url, {
                timeout: timeout,
                keepalive: true,
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Basic ".concat(btoa("".concat(username, ":").concat(password)))
                },
                body: JSON.stringify(requestBody)
            });
            return;
        }
        axios_default().post(url, requestBody, {
            headers: {
                "Content-Type": "application/json"
            },
            auth: {
                username: username,
                password: password
            },
            timeout: timeout
        }).then(function(res) {
            callback === null || callback === void 0 ? void 0 : callback({
                status: "success",
                data: res
            });
        }).catch(function(error) {
            console.error(error);
            callback === null || callback === void 0 ? void 0 : callback({
                status: "failed",
                data: error
            });
        });
    };
    return {
        SETrackEvent: SETrackEvent,
        SETransformAttrs: SETransformAttrs
    };
};

;// CONCATENATED MODULE: ./app/PelatihanMandiriPage/hooks/useSETrackEvent.ts




var DEFAULT_PARAMS_TRACKER = {
    source: "untuk_anda"
};
var getUserId = function() {
    var ref;
    var session = (0,utils_auth/* getSession */.Gg)();
    return {
        user_id: session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id
    };
};
var useSETrackEvent_getUserData = function() {
    var ref, ref1;
    var session = (0,utils_auth/* getSession */.Gg)();
    return {
        user_id: session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.id,
        user_email: session === null || session === void 0 ? void 0 : (ref1 = session.user) === null || ref1 === void 0 ? void 0 : ref1.email
    };
};
var getUserAgent = function() {
    return {
        user_agent: (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || ""
    };
};
function useSETrackerEvent() {
    var SETrackEvent = useSatuEventTracker().SETrackEvent;
    var SETrackTopNav = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_top_nav_v3",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, DEFAULT_PARAMS_TRACKER, params, getUserId(), getUserAgent())
            }
        });
    };
    var SETrackPromotionTopic = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_promotion_topic_v3",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, DEFAULT_PARAMS_TRACKER, params, getUserId(), getUserAgent())
            }
        });
    };
    var SETrackRecommendationCollection = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_theme_collection_v3",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, DEFAULT_PARAMS_TRACKER, params, getUserId(), getUserAgent())
            }
        });
    };
    var SETrackProgressTopic = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_progress_topic_v3",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, DEFAULT_PARAMS_TRACKER, params, getUserId(), getUserAgent())
            }
        });
    };
    var SETrackWebinar = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_webinar_v3",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, DEFAULT_PARAMS_TRACKER, params, getUserId(), getUserAgent())
            }
        });
    };
    var SETrackTopicList = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_choose_topic_v2",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, params, useSETrackEvent_getUserData(), getUserAgent())
            }
        });
    };
    var SETrackChooseOrder = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_order_topic_v2",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, params, useSETrackEvent_getUserData(), getUserAgent())
            }
        });
    };
    var SETrackMoEngageEvent = function(param) {
        var activityType = param.activityType, deviceId = param.deviceId;
        var ref;
        var session = (0,utils_auth/* getSession */.Gg)();
        SETrackEvent({
            eventName: "guru_core_pwa_event_tracker_v1",
            eventParams: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                activity_type: activityType,
                event_name: "GURU_CORE_APP",
                device_id: deviceId
            }, getUserId()), {
                attributes: [
                    {
                        key: "user_agent",
                        value: {
                            string_value: (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) || ""
                        }
                    },
                    {
                        key: "teacher_email",
                        value: {
                            string_value: session === null || session === void 0 ? void 0 : (ref = session.user) === null || ref === void 0 ? void 0 : ref.email
                        }
                    }, 
                ]
            })
        });
    };
    var SETrackSubmitAksiNyata = function(params) {
        SETrackEvent({
            eventName: "microlearning_click_submit_aksi_nyata_v2",
            eventParams: {
                event_detail: (0,_object_spread/* default */.Z)({}, params, useSETrackEvent_getUserData(), getUserAgent())
            }
        });
    };
    return {
        SETrackTopNav: SETrackTopNav,
        SETrackPromotionTopic: SETrackPromotionTopic,
        SETrackRecommendationCollection: SETrackRecommendationCollection,
        SETrackProgressTopic: SETrackProgressTopic,
        SETrackWebinar: SETrackWebinar,
        SETrackTopicList: SETrackTopicList,
        SETrackChooseOrder: SETrackChooseOrder,
        SETrackMoEngageEvent: SETrackMoEngageEvent,
        SETrackSubmitAksiNyata: SETrackSubmitAksiNyata
    };
}


/***/ })

}]);